import { render, staticRenderFns } from "./GitLogsTable.vue?vue&type=template&id=4f2e3fa1&scoped=true"
import script from "./GitLogsTable.vue?vue&type=script&lang=js"
export * from "./GitLogsTable.vue?vue&type=script&lang=js"
import style0 from "./GitLogsTable.vue?vue&type=style&index=0&id=4f2e3fa1&prod&lang=scss&scoped=true"
import style1 from "../TableCustomSort.scss?vue&type=style&index=1&id=4f2e3fa1&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2e3fa1",
  null
  
)

export default component.exports